module.exports = __webpack_public_path__ + "img/uc.d0accf3a.png";